import { render } from "./Supplementplus20250114.vue?vue&type=template&id=2ff922b4"
const script = {}

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__